var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 168,
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-19 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 177.167C34.8333 177.625 34.4583 178 34 178 33.5417 178 33.1667 177.625 33.1667 177.167L33.1667 176.333 32.75 172.167 34.4167 172.167 34.8333 176.333 34.8333 177.167ZM31.5 177.167C31.5 177.625 31.125 178 30.6667 178 30.2083 178 29.8333 177.625 29.8333 177.167L29.8333 176.333 29.625 172.167 31.2917 172.167 31.5 176.333 31.5 177.167ZM28.1667 176.333 28.1667 177.167C28.1667 177.625 27.7917 178 27.3333 178 26.875 178 26.5 177.625 26.5 177.167L26.5 176.333 26.7083 172.167 28.375 172.167 28.1667 176.333ZM27.3333 183 24 183 24 179.667 27.3333 179.667 27.3333 183ZM23.1667 177.167 23.1667 176.333 23.5833 172.167 25.25 172.167 24.8333 176.333 24.8333 177.167C24.8333 177.625 24.4583 178 24 178 23.5417 178 23.1667 177.625 23.1667 177.167ZM35.6667 170.917 22.3333 170.917 21.5 176.333 21.5 177.167C21.5 177.625 21.875 178 22.3333 178L22.3333 185.083 29.4167 185.083 29.4167 179.667 34 179.667 34 185.083 35.6667 185.083 35.6667 178C36.125 178 36.5 177.625 36.5 177.167L36.5 176.333 35.6667 170.917Z",
    fill: "#7030A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconStore);
export default __webpack_public_path__ + "static/media/nav-icon-store.1b24d2ce2d99e482e9cab36f2fd6b51c.svg";
export { ForwardRef as ReactComponent };